export const DEFAULT_FILTER_BUILDER_DROPDOWN_WIDTH = '240px';
